import React from "react";
import logo from "../../images/logo.png";
import { NavLink } from "react-router-dom";

const navauth = () => {
  return (
    <div className="container">
      <nav class="navbar navbar-expand-lg lg:px-[50px] ">
        <div class="container-fluid">
          <NavLink to="/">
            <img src={logo} className="img-fluid logo" alt="logo" />
          </NavLink>
        </div>
      </nav>
    </div>
  );
};

export default navauth;
